<template>
	<FormGroupBox title="Datos del cliente">
		<b-form-row>
			<b-form-group class="col-6" label="Nombres">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientFirstName"
					required
				/>
			</b-form-group>
			<b-form-group class="col-6" label="Apellidos">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientLastName"
					required
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group class="col-6" label="Telefono" v-if="$hasPermission('reservation.client.contact')">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientPhone"
					required
				/>
			</b-form-group>
			<b-form-group class="col-6" label="Correo" v-if="$hasPermission('reservation.client.contact')">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientEmail"
					required
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group class="col-6" label="Idioma">
				<b-form-select
					:disabled="!canBeUpdated"
					size="sm"
					v-model="clientLang"
				>
					<b-form-select-option value="en"
						>Ingles</b-form-select-option
					>
					<b-form-select-option value="es"
						>Español</b-form-select-option
					>
				</b-form-select>
			</b-form-group>
			<b-form-group  class="col-6" label="." v-if="$hasPermission('reservation.taxData')">
				<b-button variant="primary" size="sm" @click="openBillingInfo = !openBillingInfo"><md-icon v-if="hasBillingInfo" icon="info" /> Datos fiscales <md-icon :icon="openBillingInfo ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"/></b-button>
			</b-form-group>
		</b-form-row>
		<b-collapse :visible="openBillingInfo">
			<hr>
			<b-form-group label="Empresa">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientBillingInfo.companyName"
				/>
			</b-form-group>
			<b-form-group label="RFC">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientBillingInfo.rfc"
				/>
			</b-form-group>
			<b-form-group label="Direccion 1">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientBillingInfo.addressLine1"
				/>
			</b-form-group>
			<b-form-group label="Direccion 2">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientBillingInfo.addressLine2"
				/>
			</b-form-group>
			<b-form-group label="Ciudad">
				<b-form-input
					:disabled="!canBeUpdated"
					type="text"
					size="sm"
					v-model="clientBillingInfo.city"
				/>
			</b-form-group>
			<b-form-row>
				<b-form-group class="col-6" label="Pais">
					<b-form-input
						:disabled="!canBeUpdated"
						type="text"
						size="sm"
						v-model="clientBillingInfo.country"
					/>
				</b-form-group>
				<b-form-group class="col-6" label="Codigo postal">
					<b-form-input
						:disabled="!canBeUpdated"
						type="text"
						size="sm"
						v-model="clientBillingInfo.postalCode"
					/>
				</b-form-group>
			</b-form-row>
		</b-collapse>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import {mapFields} from '../helpers/helpers'
export default {
	components: {
		FormGroupBox
	},
	props: {
		canBeUpdated: Boolean
	},
	computed: {
		//El viewModel principal esta en el modulo reservation de vuex store
		...mapFields({
			fields: ['clientFirstName','clientLastName','clientPhone','clientEmail','clientLang','clientBillingInfo'],
			base: 'viewModel',
			mutation: 'SET_UPDATE_MODEL',
			module: 'reservation'
		}),
		hasBillingInfo(){
			return this.clientBillingInfo.companyName || this.clientBillingInfo.rfc
		}
	},
	data(){
		return {
			openBillingInfo:false,
		}
	}
};
</script>
